<template>
<v-main >

  <v-layout row wrap>
    <v-flex xs12 sm12 class="mx-4 mt-2">

      <v-card class="mx-2 rounded-xl">
        <v-card-title>
          <v-toolbar-title>
            Técnicos da Unidade
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="searchAtivo" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table no-data-text="Nenhum item disponível" :headers="headers" :items="listaFuncionariosAtivos" :search="searchAtivo">
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text small v-on="on" @click="cadastrarTecnicoExame(item)">
                  <v-icon medium color="success">add</v-icon>
                </v-btn>
              </template>
              <span>Adicionar exames ao técnico</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn text small v-on="on" @click="cadastrarTecnicoServico(item)">
                    <v-icon medium color="success">local_hospital</v-icon>
                  </v-btn>
                </template>
                <span>Adicionar serviços ao técnico</span>
              </v-tooltip>
            <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" icon small v-on="on" @click="alterarDadosTecnico(item)">
                      <v-icon medium color="success">edit</v-icon>
                    </v-btn>

                  </template>
                  <span>Alterar dados do técnico</span>
                </v-tooltip>
          </template>

        </v-data-table>
        <!-- <v-data-table no-data-text="Nenhum item disponível" :headers="headers" :items="listaFuncionariosAtivos" :search="searchAtivo">
          <template v-slot:items="props">
            <td class="title">{{ props.item.nome }}</td>

            <td class="justify-center layout px-0">

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn fab small v-on="on" @click="cadastrarTecnicoExame(props.item)">
                    <v-icon medium color="success">add</v-icon>
                  </v-btn>
                </template>
                <span>Adicionar exames ao técnico</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn fab small v-on="on" @click="cadastrarTecnicoServico(props.item)">
                    <v-icon medium color="success">local_hospital</v-icon>
                  </v-btn>
                </template>
                <span>Adicionar serviços ao técnico</span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Sua busca por "{{ searchAtivo }}" não encontrou resultados.
            </v-alert>
          </template>
        </v-data-table> -->
      </v-card>
    </v-flex>

    <!-- <v-flex xs12 sm6 class="pa-3 pb-4">

  <v-card>
    <v-card-title>
      <v-toolbar-title>Técnicos desativos
        </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="searchDesativo"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      no-data-text="Nenhum item disponível"
      :headers="headersDesativado"
      :items="listaFuncionariosDesativos"
      :search="searchDesativo"
    >
      <template v-slot:items="props">
        <td class="Subheading">{{ props.item.nome }}</td>

        <td class="justify-center layout px-0">
          <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                    fab
                    color="#4DB6AC"
                    small
                    v-on="on"
                    @click="ativarMedico(props.item)"
                    ><v-icon medium >add</v-icon></v-btn>
                  </template>
                  <span>ativar técnico</span>
              </v-tooltip>
          </td>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Sua busca por "{{ searchDesativo }}" não encontrou resultados.
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</v-flex> -->

  </v-layout>

  <v-layout style="height: 90px; position: relative" right bottom>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'listaAdministrador',
  data () {
    return {
      page: 1,
      tipo: 8,
      searchAtivo: '',
      searchDesativo: '',
      isEditing: true,
      listaFuncionariosAtivos: [],
      listaFuncionariosDesativos: [],
      administradorSelecionado: null,
      headers: [{
        text: 'Nome do Técnico',
        align: 'center',
        sortable: true,
        value: 'nome'
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false
      }
      ],
      headersDesativado: [{
        text: 'Nome do Técnico',
        align: 'center',
        sortable: true,
        value: 'nome'
      },

      {
        text: 'Ativar médico',
        align: 'center',
        value: 'name',
        sortable: false
      }

      ],
      listaFuncionarios: [],
      user: null,
      items: [{
        username: 'Elvis',
        idMedico: 1
      },
      {
        username: 'Cassio',
        idMedico: 3
      },
      {
        username: 'Leandro',
        idMedico: 2
      },
      {
        username: 'Ana',
        idMedico: 15
      },
      {
        username: 'Ricardo',
        idMedico: 14
      },
      {
        username: 'Cleison',
        idMedico: 22
      }
      ]
    }
  },
  components: {
    // HelloWorld
  },
  mounted () {
    console.log('em mounted lista medicos...')
    this.user = this.$store.getters.usuario
    // console.log(this.user);
    this.retornarFuncionarios()
  },
  methods: {

    retornarFuncionarios () {
      console.log('em retornar funcionarios medicos...')
      administradorUnidadeService.administradorUnidade
        .retornarFuncionarios(this.tipo)
        .then(rsp => {
          console.log('rsp oi:')
          this.listaFuncionarios = rsp.data
          this.listaFuncionarios.forEach(funcionario => {
            if (funcionario.ativo) {
              this.listaFuncionariosAtivos.push(funcionario)
            } else {
              this.listaFuncionariosDesativos.push(funcionario)
            }
          })
          console.log(this.listaFuncionarios)
          // console.log(this.listaChamadas);
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    ativarMedico (item) {
      if (confirm('Deseja ativar esse Médico?')) {
        // this.items.splice(index, 1)
        const index = this.listaFuncionariosDesativos.indexOf(item)
        console.log('excluir atendet..')
        console.log(typeof (item.username))
        administradorUnidadeService.administradorUnidade.ativarFuncionario(item.username, this.tipo)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosDesativos.splice(index, 1)
              this.listaFuncionariosAtivos.push(item)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    desativarMedico (item) {
      if (confirm('Deseja desativar esse Médico?')) {
        // this.items.splice(index, 1)
        const index = this.listaFuncionariosAtivos.indexOf(item)
        console.log('item.username..')
        administradorUnidadeService.administradorUnidade.desativarFuncionario(item.username, this.tipo)
          .then(rsp => {
            console.log('rsp oi:', rsp)
            if (rsp.data == true) {
              this.listaFuncionariosAtivos.splice(index, 1)
              this.listaFuncionariosDesativos.push(item)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    importarTecnicos () {
      console.log('em retornar funcionarios atendente...')
      administradorUnidadeService.administradorUnidade
        .importarTecnicos()
        .then(rsp => {
          console.log('rsp oi:')
          console.log(rsp.data)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    cadastrarTecnicoExame (item) {
      console.log(' em cadastrar medico servico...')
      this.$router.push({
        name: 'cadastrarTecnicoExame',
        params: {
          item: item
        }
      })
    },
    cadastrarTecnicoServico (item) {
      console.log(' em cadastrar medico servico...')
      this.$router.push({
        name: 'cadastrarTecnicoServico',
        params: {
          item: item
        }
      })
    },
    alterarDadosTecnico (data) {
      this.$router.push({
        name: 'alterarDadosTecnico',
        params: { medico: data }
      })
    }

  },
  created () {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

.rounded-card {
  border-radius: 35px;
}

#mybutton2 {
  position: fixed;
  bottom: 30px;
  right: 20px;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
